module.exports = __webpack_public_path__ + "img/level_five_lock.9dd829c1.png";